import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { Inspection, Inspector, ListFilters, ListResults, Policy, PolicyGroup, PolicyList } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PolicyService {
  constructor(protected http: HttpClient) {}

  public list(filters?: ListFilters) {
    return this.http.get<ListResults<PolicyList>>(`${env.APIUrl}/policy`, { params: filters as any });
  }

  public get(id: number) {
    return this.http.get<Policy>(`${env.APIUrl}/policy/${id}`).toPromise();
  }

  public getByNumber(number: string) {
    return this.http.get<Policy>(`${env.APIUrl}/policy/number`, { params: { number } }).toPromise();
  }

  public archived(filters?: ListFilters) {
    return this.http
      .get<ListResults<PolicyList>>(`${env.APIUrl}/policy/archived`, { params: filters as any })
      .toPromise();
  }

  public archive(id: number, archiveInspection: boolean = false) {
    return this.http
      .put<Policy>(`${env.APIUrl}/policy/${id}/archive`, { archiveInspection: archiveInspection })
      .toPromise();
  }

  public restore(id: number, restoreInspection: boolean = false) {
    return this.http
      .put<Policy>(`${env.APIUrl}/policy/${id}/restore`, { restoreInspection: restoreInspection })
      .toPromise();
  }

  public remove(id: number) {
    return this.http.delete<Policy>(`${env.APIUrl}/policy/${id}`).toPromise();
  }

  public edit(id: number, policy: Policy) {
    return this.http.put<Policy>(`${env.APIUrl}/policy/${id}`, policy).toPromise();
  }

  public create(policy: Policy) {
    return this.http.post<Policy>(`${env.APIUrl}/policy`, policy).toPromise();
  }

  public inspectors(policyId: number, search = '') {
    return this.http.get<Inspector[]>(`${env.APIUrl}/policy/${policyId}/inspectors`, { params: { search } });
  }

  public inspections(policyId: number) {
    return this.http.get<Inspection[]>(`${env.APIUrl}/policy/${policyId}/inspections`);
  }
  public count() {
    return this.http.get<{ active: boolean; count: number }[]>(`${env.APIUrl}/policy/count`).toPromise();
  }

  public groups() {
    return this.http.get<ListResults<PolicyGroup>>(`${env.APIUrl}/policyGroup`).toPromise();
  }

  public addGroup(policyId: number, groupName: string) {
    return this.http
      .post<PolicyGroup>(`${env.APIUrl}/policyGroup/withPolicy/${policyId}`, { name: groupName })
      .toPromise();
  }
}
